export const transformString = (str: string) => {
  return str.replace(/\s+/g, '')
  .trim()
  .toLowerCase()
}